export class MembershipLanding {
    constructor(public bodyElement: any) {
        
        if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
            window.location.reload();
        }

        let radioTriggers = document.getElementsByClassName('js-section-trigger');
        let membershipContainers = document.getElementsByClassName('js-section-target');
        
        let appraiserOfficeTrigger = document.getElementById('appraiser-office');

        for (let i = 0; i < radioTriggers.length; i++)        {
            radioTriggers[i].addEventListener('change', (e) => {
                let membershipType = radioTriggers[i].getAttribute("data-membership-type");
                let membershipGroup = radioTriggers[i].getAttribute("data-membership-group");
                for (let j = 0; j < membershipContainers.length; j++) {
                    let membershipContainer = membershipContainers[j] as HTMLElement;
                    if (membershipContainer.getAttribute("data-membership-type") == membershipType) {
                        this.showElement(membershipContainer);
                    }
                    else if (membershipContainer.getAttribute("data-membership-group") == membershipGroup) {
                        this.hideElement(membershipContainer);
                    }
                }
            });
        }
    }
    
    toggleElement(element: HTMLElement) {
        if (element.style.display === 'block') {
            element.style.display = "none";

        } else {
            element.style.display = "block";
        }
    }

    hideElement(element: HTMLElement) {
        if (element)
            element.style.display = "none";
    }

    showElement(element: HTMLElement) {
        if (element)
            element.style.display = "block";
    }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/membership-landing.ts